import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import { TripService } from '../visit-report.service';
import { VisitAttributes } from '@albatrosdeveloper/ave-models-package';
import { LOCALIZED_PROPERTIES, VISIT_REPORT_EXPORT_ID, VISIT_REPORT_TITLE } from './visit-report.constants';

@Injectable()
export class VisitReportExport {
  constructor(
    private exportService: ExportService,
    private tripService: TripService,
  ) {}

  private transformItem(item: VisitAttributes) {
    const materials = get(item, 'detail', []).map((detail: any) => {
        return {
            code: get(detail, 'material.code', '??'),
            name: get(detail, 'material.name', '??'),
            unitPrice: get(detail, 'unitPrice', 0),
            totalPrice: get(detail, 'total', 0),
        };
    });

    return {
      trip: get(item, 'trip.id', '??'),
      route: `${get(item, 'subRoute.externalKeys.code', '??')} ${get(item, 'subRoute.name', '??')}`,
      user: get(item, 'user', '??'),
      day: get(item, 'day', '??'),
      visitDay: get(item, 'visitsIndicator.VisitDay', '??'),
      visitaExtraRuta: get(item, 'visitsIndicator.VisitaExtraRuta', '??'),
      visitaEfectuada: get(item, 'visitsIndicator.VisitaEfectuada', '??'),
      visitaFaltante: get(item, 'VisitaFaltante', '??'),
      percent_visit: get(item, 'percent_visit', '??'),
      visitaEfectiva: get(item, 'visitaEfectiva', '??'),
      efectividad: get(item, 'Efectividad', '??'),
      totalRouteDurationHours: this.formatNumberDate(get(item, 'totalRouteDurationHours', 0) as number),
      totalVisitDurationHours: this.formatNumberDate(get(item, 'totalVisitDurationHours', 0) as number),
      tripDurationHoursTeoric: this.formatNumberDate(get(item, 'tripDurationHoursTeoric', 0) as number),
      tripDurationHours: this.formatNumberDate(get(item, 'tripDurationHours', 0) as number),
    };
  }

  private formatNumberDate(tiempoDecimal: number): string {

    if (tiempoDecimal == null || isNaN(tiempoDecimal)) {
      return '--:--:--';
    }
    // Calcular horas, minutos y segundos
    const horas = Math.floor(tiempoDecimal);
    const minutos = Math.floor((tiempoDecimal - horas) * 60);
    const segundos = Math.round(((tiempoDecimal - horas) * 60 - minutos) * 60);

    // Usar padStart para asegurar que siempre tenga 2 dígitos
    const horasFormateadas = String(horas).padStart(2, '0');
    const minutosFormateados = String(minutos).padStart(2, '0');
    const segundosFormateados = String(segundos).padStart(2, '0');

    // Devolver el tiempo en formato de "00:00:00"
    return `${horasFormateadas}:${minutosFormateados}:${segundosFormateados}`;
  }


  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: VISIT_REPORT_EXPORT_ID,
      title: VISIT_REPORT_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(VISIT_REPORT_TITLE, LOCALIZED_PROPERTIES);
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.tripService.findByFilter(buildQuery(
          seed(this.tripService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(VISIT_REPORT_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(VISIT_REPORT_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
